import { OralSurgeryEnum } from "requests";

export const ORAL_SURGERY_OPTIONS = [
  { value: OralSurgeryEnum.MassResection, label: "Mass Resection" },
  { value: OralSurgeryEnum.BiopsyIncisional, label: "Biopsy Incisional" },
  { value: OralSurgeryEnum.BiopsyExcisional, label: "Biopsy Excisional" },
  { value: OralSurgeryEnum.OnfOafRepair, label: "ONF/OAF Repair" },
  { value: OralSurgeryEnum.JawFxStabilization, label: "Jaw Fx Stabilization" },
  { value: OralSurgeryEnum.AcrylicWireButtons, label: "Acrylic/Wire/Buttons" }
];
